import SearchableSelect from './SearchableSelect';
import YearSelect from './YearSelect';
import { getDefaultDashboardFilters, yearDateRange, detectSelectedYear } from '../utils/filters';

export default function FilterBar({ filters, onChange, options }) {
  function set(key, value) {
    onChange({ ...filters, [key]: value });
  }

  function setYear(year) {
    onChange({ ...filters, ...(year ? yearDateRange(year) : { from: '', to: '' }) });
  }

  function setChannel(value) {
    // Narrowing the Channel can invalidate the current Sub-Channel selection (it may
    // belong to a different Channel), so clear it rather than leave a stale filter applied.
    const availableSubChannels = value ? options.channelSubChannels?.[value] ?? [] : null;
    const subChannelStillValid = !availableSubChannels || availableSubChannels.includes(filters.subChannel);
    onChange({ ...filters, channel: value, subChannel: subChannelStillValid ? filters.subChannel : '' });
  }

  const channelItems = (options.channels || []).map((c) => ({ code: c, name: c }));
  const categoryItems = (options.categories || []).map((c) => ({ code: c, name: c }));
  const availableSubChannels = filters.channel
    ? options.channelSubChannels?.[filters.channel] ?? []
    : options.subChannels || [];
  const subChannelItems = availableSubChannels.map((s) => ({ code: s, name: s }));

  return (
    <div className="bg-white border border-gray-200 rounded-lg p-4 mb-6 flex flex-wrap gap-4 items-end">
      <div>
        <label className="block text-xs font-medium text-gray-600 mb-1">From</label>
        <input
          type="date"
          value={filters.from}
          onChange={(e) => set('from', e.target.value)}
          className="border border-gray-300 rounded px-2 py-1.5 text-sm"
        />
      </div>
      <div>
        <label className="block text-xs font-medium text-gray-600 mb-1">To</label>
        <input
          type="date"
          value={filters.to}
          onChange={(e) => set('to', e.target.value)}
          className="border border-gray-300 rounded px-2 py-1.5 text-sm"
        />
      </div>

      <YearSelect years={options.years} value={detectSelectedYear(filters)} onChange={setYear} />

      <SearchableSelect
        label="Channel"
        value={filters.channel}
        onChange={setChannel}
        items={channelItems}
      />
      <SearchableSelect
        label="Sub-Channel"
        value={filters.subChannel}
        onChange={(v) => set('subChannel', v)}
        items={subChannelItems}
      />
      <SearchableSelect
        label="Customer"
        value={filters.customerCode}
        onChange={(v) => set('customerCode', v)}
        items={options.customers}
      />
      <SearchableSelect
        label="Salesman"
        value={filters.salesmanCode}
        onChange={(v) => set('salesmanCode', v)}
        items={options.salesmen}
      />
      <SearchableSelect
        label="Product"
        value={filters.productCode}
        onChange={(v) => set('productCode', v)}
        items={options.products}
      />
      <SearchableSelect
        label="Category"
        value={filters.category}
        onChange={(v) => set('category', v)}
        items={categoryItems}
      />

      <button
        onClick={() => onChange(getDefaultDashboardFilters())}
        className="text-xs text-blue-600 hover:underline mb-1.5"
      >
        Clear filters
      </button>
    </div>
  );
}
